module.exports = __webpack_public_path__ + "img/check-grey.d7fa0ceb.svg";